import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { Notification } from "../../templates/Notification"
import { useEffect, useCallback, useState } from 'react';
import { fetchNotifications, resetNotificationsState, updateNotificationRequest } from './../../../redux/notification/actions';
import { useHistory } from "react-router-dom";
import { clearSpecificRequest } from "../../../redux/request/action";
import { FETCH_NOTIFICATION_REQUEST } from "../../../redux/notification/actionType";
import { Map } from 'immutable';
import { arrayToObject } from "../../../utils/helpers/transform";

const NotificationPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  // TODO: Will be used for refactoring pagination
  // const [lastElement, setLastElement] = useState(undefined);
  // const [notificationsDataDoc, setNotificationsDataDoc] = useState({});
  const [notificationsData, setNotificationsData] = useState({});

  const notifications = useSelector(
    (state: RootStateOrAny) =>
      state.requestStore?.[FETCH_NOTIFICATION_REQUEST]
  );

  const user = useSelector((state: RootStateOrAny) => state.auth.user);

  const dispatchFetchNotifications = useCallback(
    (startAt?: any, limit = undefined) => dispatch(fetchNotifications([
      ["type", "in", (user.isAdmin || user.isSuperAdmin) ? ["move", "commented", "schedule", "summary"] : ['commented', 'move', 'schedule', 'summary', 'applied', 'end', 'response', 'emailResponse']]
    ], startAt, limit)),
    [dispatch, user]
  )

  useEffect(() => {
    dispatch(dispatchFetchNotifications());
    return () => {
      dispatch(clearSpecificRequest(FETCH_NOTIFICATION_REQUEST));
      dispatch(resetNotificationsState());
    }
  }, [dispatch]);

  useEffect(() => {
    dispatch(dispatchFetchNotifications());
    return () => {
      dispatch(clearSpecificRequest(FETCH_NOTIFICATION_REQUEST));
      dispatch(resetNotificationsState());
    }
  }, [dispatch]);

  useEffect(() => {
    let interval: any = null;
    if (currentPage === 1) {
      interval = setInterval(() => {
        dispatch(dispatchFetchNotifications(undefined, pageSize));
      }, 4000);
    }
    return () => clearInterval(interval);
  }, [dispatch, currentPage]);

  useEffect(() => {
    if (notifications && notifications?.response) {
      // TODO: Will be used for refactoring pagination
      // const filterNotifications = notifications.response.data.filter((notification: any) => {
      //   return notification.type === 'commented' && user && !notification.description.includes(user.name) && user.isAdmin ? false :
      //     notification.user.id === null || notification.user.id !== user.id ? true : false;
      // });

      const arrToObj = Map(arrayToObject(notifications.response.data));
      const mapNotificationsData = Map(notificationsData);
      const newNotificationsData = mapNotificationsData.mergeDeep(arrToObj);
      setNotificationsData(newNotificationsData.toJS());
      // setLastElement(notifications.response.lastElement);
    }
  }, [notifications]);



  const handleOnChange = (page: any, currPageSize: any) => {
    // TODO: Will be used for refactoring pagination
    // const mappedData = onMapNotificationsData(Object.values(notificationsDataDoc));
    // if (pageSize === currPageSize) {
    //   if (page > 1) {
    //     if (currentPage > page) {
    //       dispatchFetchNotifications(mappedData[((page - 1) * currPageSize) - 1].docData, currPageSize);
    //     } else {
    //       console.log('next');
    //       dispatchFetchNotifications(lastElement, currPageSize);
    //     }
    //   } else {
    //     dispatchFetchNotifications(undefined, currPageSize);
    //   }
    //   setCurrentPage(page);
    // } else {
    //   setCurrentPage(1);
    //   dispatchFetchNotifications(undefined, page * currPageSize);
    // }

    setCurrentPage(page);
    setPageSize(currPageSize);
    if (pageSize !== currPageSize) {
      setCurrentPage(1);
    }
  };


  const handleClickNotification = (notification: any) => {
    dispatch(updateNotificationRequest(notification.id, { read: true }));
    history.push(notification.notificationLink);
  }

  const onMapNotificationsData = (dataArr: any[]) =>
    dataArr.sort(
      (a: any, b: any) => {
        return (b.createdAt.toDate() - a.createdAt.toDate());
      },
    );

  const isInterviewer = (interviewee: string, interviewersList: any) => {
      return !!interviewersList.find((i: any) => i.name === interviewee);
    }

  const mappedNotificationsData = onMapNotificationsData(Object.values(notificationsData));

  const filteredNotifications = mappedNotificationsData.filter(notification => {
    if ((notification.type === 'commented' && user && !notification.description.includes(user.name) && (user.isAdmin || user.isSuperAdmin)) ||
      (notification.type === 'schedule' && notification?.interviewers?.length && !isInterviewer(user.name, notification?.interviewers) && (user.isAdmin || user.isSuperAdmin)) ||
      notification.user.id === user.id) {
        return false;
    }

    return true;
  });

  // TODO: Will be used for refactoring pagination
  // const nextPage = filteredNotifications.length < pageSize ? filteredNotifications.length : filteredNotifications.length + 1;
  // const total = currentPage > 1 ? ((currentPage - 1) * pageSize) + nextPage : nextPage;

  return (
    <Notification
      user={user}
      onClickNotification={handleClickNotification}
      isLoading={!mappedNotificationsData.length && notifications?.isLoading}
      notifications={filteredNotifications}
      onChange={handleOnChange}
      currentPage={currentPage}
      total={filteredNotifications.length}
      pageSize={pageSize}
    />
  )
}

export default NotificationPage;